@if (authority && body) {
	<div class="container p-3">
		<it-breadcrumb>
			<it-breadcrumb-item
				><a routerLink="/">{{
					"it.navigation.home" | translate
				}}</a></it-breadcrumb-item
			>
			<it-breadcrumb-item
				>{{ body.label["iterlex.currentLanguage" | translate] }}
			</it-breadcrumb-item>
		</it-breadcrumb>
	</div>
	<div class="container">
		@if (body.id === "commissione") {
			<it-tab-container
				[vertical]="true"
				(tabSelected)="changeTab($event)"
			>
				@for (child of body.children; track child.id) {
					<it-tab-item
						[id]="tabPrefix + child.id"
						[label]="
							child.label['iterlex.currentLanguage' | translate]
						"
						[active]="child.id === body.children[0].id"
					>
						<div class="row">
							@for (
								dossier of dossiersAssigned[child.id];
								track dossier.workUri
							) {
								<div class="col-md-6 col-lg-4">
									<div class="card-wrapper card-space">
										<app-dossier
											class="w-100"
											[dossier]="dossier"
											[dossierType]="
												getDossierType(dossier.type)
											"
											[progressDelete]="
												progressDossierUri ===
												dossier.workUri
											"
											(deleteDossier)="
												currentDossier = $event;
												deleteDossierModal.toggle()
											"
										/>
									</div>
								</div>
							}
						</div>
					</it-tab-item>
				}
			</it-tab-container>
		} @else {
			@if (body.id !== "assemblea") {
				<div class="d-flex justify-content-between mb-4">
					<h1>{{ "iterlex.dossier-list" | translate }}</h1>
					<it-search
						[label]="'it.navigation.search' | translate"
						[searchData]="searchDossiers$"
						(searchSelectedEvent)="onSearchSelected($event)"
					/>
					<div>
						<app-notifications
							[authority]="authority"
							[body]="body"
						></app-notifications>
						<button
							type="button"
							itButton="primary"
							(click)="
								modificationsDestinations = [];
								createDossierModal.toggle()
							"
						>
							{{ "iterlex.create-dossier" | translate }}
						</button>
					</div>
				</div>
			}
			<div class="row">
				<it-checkbox
					[label]="'iterlex.show-archived-dossiers' | translate"
					toggle="true"
					inline="true"
					(click)="
						showArchivedDossiers = !showArchivedDossiers;
						updateDossiers()
					"
				></it-checkbox>
				@for (dossier of dossiers; track dossier.workUri) {
					<div class="col-md-6 col-lg-4">
						<div class="card-wrapper card-space">
							<app-dossier
								class="w-100"
								[dossier]="dossier"
								[dossierType]="getDossierType(dossier.type)"
								[progressDelete]="
									progressDossierUri === dossier.workUri
								"
								(deleteDossier)="
									currentDossier = $event;
									deleteDossierModal.toggle()
								"
							/>
						</div>
					</div>
				}
			</div>
		}
	</div>
}

<it-modal #createDossierModal>
	<ng-container modalTitle>{{
		"iterlex.create-dossier" | translate
	}}</ng-container>
	<form #newDossierForm="ngForm" (ngSubmit)="onSubmit(newDossierForm)">
		<it-select
			name="dossierType"
			[label]="'iterlex.dossier-type' | translate"
			ngModel
			required
		>
			<option selected value="">
				{{ "iterlex.select-dossier-type" | translate }}
			</option>
			@for (dossierType of dossierTypes; track dossierType.id) {
				<option [value]="dossierType.id">
					{{
						dossierType.label["iterlex.currentLanguage" | translate]
					}}
				</option>
			}
		</it-select>
		<it-input
			type="text"
			name="title"
			ngModel
			required
			[label]="'iterlex.title' | translate"
		></it-input>
		<it-input
			type="number"
			name="number"
			ngModel
			required
			[label]="'iterlex.number' | translate"
		></it-input>
		<it-input
			type="date"
			name="date"
			ngModel
			required
			[label]="'iterlex.date' | translate"
		></it-input>
		@if (newDossierForm.value.dossierType === "leggeModifica") {
			<it-input
				#modificationsDestinationInput
				type="text"
				name="modificationsDestination"
				ngModel
				[label]="'iterlex.modifications-destination' | translate"
			>
				<button
					size="xs"
					itButton="outline-primary"
					[disabled]="!newDossierForm.value.modificationsDestination"
					(click)="
						modificationsDestinations.push(
							newDossierForm.value.modificationsDestination
						);
						modificationsDestinationInput.writeValue('')
					"
					append
				>
					<it-icon name="plus"></it-icon>
				</button>
			</it-input>
			<ul>
				@for (
					modificationsDestination of modificationsDestinations;
					track modificationsDestination
				) {
					<li>
						{{ modificationsDestination }}
						<button
							size="xs"
							itButton="outline-danger"
							(click)="
								modificationsDestinations.splice($index, 1)
							"
							append
						>
							<it-icon
								name="delete"
								color="danger"
								[title]="'it.core.remove' | translate"
							></it-icon>
						</button>
					</li>
				}
			</ul>
		}
		<button
			itButton="primary"
			type="submit"
			[disabled]="
				!newDossierForm.valid ||
				(newDossierForm.value.dossierType === 'leggeModifica' &&
					modificationsDestinations.length === 0)
			"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.create-dossier" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #deleteDossierModal="itModal" closeButton="false" popconfirm="true">
	<ng-container modalTitle>{{
		"iterlex.delete-dossier-confirm" | translate
	}}</ng-container>
	@if (currentDossier) {
		<p>
			{{
				"iterlex.delete-dossier-confirm-description"
					| translate: { name: currentDossier.title }
			}}
		</p>
	}
	<ng-container footer>
		@if (currentDossier) {
			<button
				itButton="danger"
				type="button"
				data-bs-dismiss="modal"
				(click)="deleteDossier(currentDossier.workUri)"
			>
				{{ "it.core.remove" | translate }}
			</button>
		}
		<button
			itButton="outline-secondary"
			type="button"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.cancel" | translate }}
		</button>
	</ng-container>
</it-modal>
